import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/data/subtasks'
export default {
  namespaced: true,
  state: {
    loading: false,
    dataList: [],
    dataCounts: 0,
    dataItem: {
      id: null,
      id_licenses: null,
      id_tasks: null,
      title: null,
      description: null,
      close_status: 'open',
      result_notes: null,
      start_date: null,
      target_date: null,
      completed_date: null,
      timer_duration: 0,
      timer_is_running: 0,
      timer_started_at: null,
      timer_auto_stop_minutes: 0,
      id_assigned_users: null,
      id_users: null,
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
    filterParams: {
      id_tasks: null,
      close_status: null,
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
    dataList(state) {
      return state.dataList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
    filterParams(state) {
      return state.filterParams
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        id_licenses: null,
        id_tasks: null,
        title: null,
        description: null,
        close_status: 'open',
        result_notes: null,
        start_date: null,
        target_date: null,
        completed_date: null,
        timer_duration: 0,
        timer_is_running: 0,
        timer_started_at: null,
        timer_auto_stop_minutes: 0,
        id_assigned_users: null,
        id_users: null,
      }
    },
    SET_TIMER_STATE(state, { timer_is_running, timer_started_at, timer_duration }) {
      if (timer_is_running !== undefined) state.dataItem.timer_is_running = timer_is_running
      if (timer_started_at !== undefined) state.dataItem.timer_started_at = timer_started_at
      if (timer_duration !== undefined) state.dataItem.timer_duration = timer_duration
    },
  },
  actions: {
    getDataList({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_DATA_ITEM')
      commit('SET_DATA_LIST', [])
      const data = JSON.stringify(params || {})
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
    async getDataItem({ commit }, id) {
      if (Number(id)) {
        commit('SET_LOADING', true)
        commit('RESET_DATA_ITEM')
        const requestData = {
          where: {
            'subtasks.id': id,
          },
          array: false,
        }
        return axiosIns
          .post(ROOT_URL, requestData)
          .then(response => {
            commit('SET_DATA_ITEM', response.data.data)
            commit('SET_LOADING', false)
            return response.data.data
          })
          .catch(error => console.error(error))
      }
      return false
    },
    saveData({ commit }, postData) {
      commit('SET_LOADING', true)
      const data = JSON.stringify(postData)
      return axiosIns
        .post(`${ROOT_URL}/saveData`, data)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          commit('SET_LOADING', false)
          return response.data
        })
        .catch(error => {
          commit('SET_LOADING', false)
          // 400 doğrulama, 403 yetki/kilitli task, 404 kayıt yok — hepsi {status:false, message} döner
          const httpStatus = error?.response?.status
          if (httpStatus >= 400 && httpStatus < 500 && error.response.data?.status === false) {
            commit('SET_DATA_SAVE', error.response.data)
            return error.response.data
          }
          console.error(error)
          throw error
        })
    },
    completeSubtask({ commit }, { id, result_notes }) {
      commit('SET_LOADING', true)
      const data = JSON.stringify({ id, result_notes })
      return axiosIns
        .post(`${ROOT_URL}/complete`, data)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          commit('SET_LOADING', false)
          return response.data
        })
        .catch(error => {
          commit('SET_LOADING', false)
          if (error?.response?.status === 400 && error.response.data?.status === false) {
            commit('SET_DATA_SAVE', error.response.data)
            return error.response.data
          }
          return Promise.reject(error)
        })
    },
    removeData({ commit }, id) {
      commit('SET_LOADING', true)
      return axiosIns
        .post(`${ROOT_URL}/deleteData`, { id })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          commit('SET_LOADING', false)
          return response.data
        })
        .catch(error => console.error(error))
    },
    // Sekmeler aynı anda istek atabildiği için sonuç state'e yazılmaz; çağıran bileşen tutar.
    getMyList(_, params) {
      return axiosIns
        .post(`${ROOT_URL}/myList`, params)
        .then(response => response.data)
    },
    timerHeartbeat(_, id) {
      return axiosIns
        .post(`${ROOT_URL}/timer/heartbeat/${id}`)
        .catch(() => {})
    },
    timerStart({ commit }, { id, force = false }) {
      // force: BE aktif timer'ı durdurup bunu başlatır; yalnız boolean true kabul eder.
      return axiosIns
        .post(`${ROOT_URL}/timer/start/${id}`, force ? { force: true } : undefined)
        .then(response => {
          if (response.data?.data) {
            commit('SET_TIMER_STATE', response.data.data)
          }
          return response.data
        })
        .catch(error => {
          // Tek aktif timer: başka alt görevde açık timer varsa BE 409 + conflict döner.
          // Bunu hata olarak fırlatma; component modal göstersin diye payload'ı döndür.
          if (error?.response?.status === 409 && error.response.data?.conflict) {
            return error.response.data
          }
          console.error(error)
          throw error
        })
    },
    timerStop({ commit }, id) {
      return axiosIns
        .post(`${ROOT_URL}/timer/stop/${id}`)
        .then(response => {
          if (response.data?.data) {
            commit('SET_TIMER_STATE', response.data.data)
          }
          return response.data
        })
        .catch(error => {
          console.error(error)
          throw error
        })
    },
    reopenSubtask({ commit }, id) {
      commit('SET_LOADING', true)
      return axiosIns
        .post(`${ROOT_URL}/reopen`, { id })
        .then(response => {
          if (response.data) {
            commit('SET_DATA_SAVE', response.data)
            commit('SET_LOADING', false)
          }
          return response.data
        })
        .catch(error => {
          commit('SET_LOADING', false)
          const httpStatus = error?.response?.status
          if (httpStatus >= 400 && httpStatus < 500 && error.response.data?.status === false) {
            commit('SET_DATA_SAVE', error.response.data)
            return error.response.data
          }
          return Promise.reject(error)
        })
    },
  },
}
